export const OPENSALUD_DOMAIN = 'opensalud'	
export const OPENSALUD_ES_DOMAIN = 'opensalud.es'
export const OPENSALUD_MX_DOMAIN = 'opensalud.mx'
export const PRIMESALUD_DOMAIN = 'opensaludprime'
export const OPENLEGAL_DOMAIN = 'openlegal'
export const ABOGALITYPRO_DOMAIN = 'abogalitypro'
export const UNIPROMEL_DOMAIN = 'unihealth'
export const NEOM_DOMAIN = 'neom'
export const OPENSALUD4ALL_DOMAIN = 'opensalud4all'
export const MENTTUM_DOMAIN = 'menttum'
export function getDomain () {
    return window.location.hostname.includes(UNIPROMEL_DOMAIN) ? UNIPROMEL_DOMAIN : 
    (window.location.hostname.includes(OPENSALUD_MX_DOMAIN) ? OPENSALUD_MX_DOMAIN :
    (window.location.hostname.includes(PRIMESALUD_DOMAIN) ? PRIMESALUD_DOMAIN :
    (window.location.hostname.includes(OPENLEGAL_DOMAIN) ? OPENLEGAL_DOMAIN :
    (window.location.hostname.includes(ABOGALITYPRO_DOMAIN) ? ABOGALITYPRO_DOMAIN :
    (window.location.hostname.includes(NEOM_DOMAIN) ? NEOM_DOMAIN :
    (window.location.hostname.includes(OPENSALUD_ES_DOMAIN) ? OPENSALUD_ES_DOMAIN :
    (window.location.hostname.includes(OPENSALUD4ALL_DOMAIN) ? OPENSALUD4ALL_DOMAIN :
		(window.location.hostname.includes(MENTTUM_DOMAIN) ? MENTTUM_DOMAIN :
    OPENSALUD_DOMAIN))))))))
}

export const LOCALHOST_DOMAIN = 'localhost'


// WEBPACK FOOTER //
// ./src/constants/domains.js